"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
var Drawer_1 = __importDefault(require("./Drawer"));
exports.Drawer = Drawer_1.default;
exports.default = Drawer_1.default;
//# sourceMappingURL=index.js.map